import { render, staticRenderFns } from "./SoftwareOfferReleaseStatusChip.vue?vue&type=template&id=a95cca7a"
import script from "./SoftwareOfferReleaseStatusChip.vue?vue&type=script&lang=ts"
export * from "./SoftwareOfferReleaseStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports